// routes
import Router from "./routes";
// theme
import "bootstrap/dist/css/bootstrap.min.css";
import ThemeProvider from "./theme";

// components
import "./App.css";
import MotionLazyContainer from "./components/animate/MotionLazyContainer";
import { ChartStyle } from "./components/chart";
import NotistackProvider from "./components/NotistackProvider";
import { ProgressBarStyle } from "./components/ProgressBar";
import ScrollToTop from "./components/ScrollToTop";
import ThemeSettings from "./components/settings";
// ----------------------------------------------------------------------
import { NPSModal } from "@components/nps-survey/NPSModal";
import { VersionNotifier } from "@components/VersionNotifier";
import ErrorBoundary from "@components/ErrorBoundary";
import { GlobalStyles } from "@mui/material";
import { BannerProvider } from "src/contexts/BannerContext";
import withClearCache from "./ClearCache";
import { ENABLE_FRESHDESK_CHAT } from "./constants/settings";
import FreshChatWidget from "./ExternalIntegrations/FreshChatWidget";
import { globalStyles } from "./pages/formvalidation/Component/styles";

const ClearCacheComponent = withClearCache(MainApp);

export default function App() {
  return <ClearCacheComponent />;
}

declare global {
  interface Window {
    // Intercom: any;
    // intercomSettings: any;
    fcSettings?: any;
    fcWidget?: {
      init: (config: Record<string, any>) => void;
      setExternalId: (id: string | null) => void;
      user: {
        setFirstName: (name: string) => Promise<void>;
        setEmail: (email: string) => Promise<void>;
        setProperties: (props: Record<string, string>) => Promise<void>;
        clear: () => Promise<void>;
        get: any;
        setLocale: (lang: string) => Promise<void>;
      };
      on: (e: string, t: any) => void;
      open: () => void;
      isOpen: () => boolean;
      close?: () => void;
      destroy: () => void;
      hide: () => void;
      isInitialized: () => boolean;
      setConfig: (config: any) => void;
      setLocale: (lang: string) => void;
    };
  }
}

function MainApp() {
  return (
    <MotionLazyContainer>
      <BannerProvider>
        <ThemeProvider>
          <ThemeSettings>
            <NotistackProvider>
              {ENABLE_FRESHDESK_CHAT && <FreshChatWidget />}
              <GlobalStyles styles={globalStyles} />
              <ProgressBarStyle />
              <ChartStyle />
              <ScrollToTop />
              <ErrorBoundary>
                <Router />
              </ErrorBoundary>
            </NotistackProvider>
          </ThemeSettings>
          <NPSModal />
        </ThemeProvider>
        <VersionNotifier />
      </BannerProvider>
    </MotionLazyContainer>
  );
}
